import * as R from 'ramda';
import { Project } from '../../project/Project';
import { mapBuildings } from '../../project/map/mapBuildings';

export const migrateProject9To10 = (project: Project): Project =>
  mapBuildings(R.dissoc('title'))(project);
